var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_675_2268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_675_2268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50195 20C4.98529 20 3.68945 19.475 2.61445 18.425C1.53945 17.375 1.00195 16.0917 1.00195 14.575C1.00195 13.275 1.39362 12.1167 2.17695 11.1C2.96029 10.0833 3.98529 9.43333 5.25195 9.15C5.66862 7.61667 6.50195 6.375 7.75195 5.425C9.00195 4.475 10.4186 4 12.002 4C13.952 4 15.6061 4.67917 16.9645 6.0375C18.3228 7.39583 19.002 9.05 19.002 11C20.152 11.1333 21.1061 11.6292 21.8645 12.4875C22.6228 13.3458 23.002 14.35 23.002 15.5C23.002 16.75 22.5645 17.8125 21.6895 18.6875C20.8145 19.5625 19.752 20 18.502 20H13.002C12.452 20 11.9811 19.8042 11.5895 19.4125C11.1978 19.0208 11.002 18.55 11.002 18V12.85L9.40195 14.4L8.00195 13L12.002 9L16.002 13L14.602 14.4L13.002 12.85V18H18.502C19.202 18 19.7936 17.7583 20.277 17.275C20.7603 16.7917 21.002 16.2 21.002 15.5C21.002 14.8 20.7603 14.2083 20.277 13.725C19.7936 13.2417 19.202 13 18.502 13H17.002V11C17.002 9.61667 16.5145 8.4375 15.5395 7.4625C14.5645 6.4875 13.3853 6 12.002 6C10.6186 6 9.43945 6.4875 8.46445 7.4625C7.48945 8.4375 7.00195 9.61667 7.00195 11H6.50195C5.53529 11 4.71029 11.3417 4.02695 12.025C3.34362 12.7083 3.00195 13.5333 3.00195 14.5C3.00195 15.4667 3.34362 16.2917 4.02695 16.975C4.71029 17.6583 5.53529 18 6.50195 18H9.00195V20H6.50195Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUpload);
export default __webpack_public_path__ + "static/media/newUpload.b8fa7fdf418e9f1c79da63a314a72b26.svg";
export { ForwardRef as ReactComponent };